import { render, staticRenderFns } from "./WorkbenchV2.vue?vue&type=template&id=23830d36&scoped=true"
import script from "./WorkbenchV2.vue?vue&type=script&lang=js"
export * from "./WorkbenchV2.vue?vue&type=script&lang=js"
import style0 from "./WorkbenchV2.vue?vue&type=style&index=0&id=23830d36&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23830d36",
  null
  
)

export default component.exports